<template>
  <div class="app-container">
    <div class="box">软科排名</div>
    <div class="app">
      <div>
        <div class="title">
          <div class="left">
            <p>中国大学排名 (总榜)<span>共 800 所学校</span></p>
          </div>
          <div class="right">
            <input
              type="text"
              placeholder="请输入院校名称"
              v-model="schoolName"
              @keyup.enter="getSchoolRank"
            /><i class="el-icon-search" @click="getSchoolRank"></i>
          </div>
        </div>
        <el-table
          size="small"
          current-row-key="id"
          :data="dataList"
          stripe
          highlight-current-row
          :row-style="{ height: '50px' }"
        >
          <el-table-column
            prop="ranking"
            align="center"
            label="排名"
          ></el-table-column>
          <el-table-column label="院校名称" align="center">
            <template slot-scope="scope">
              <div class="img">
                <img
                  :src="
                    require('../../assets/img/rk_images/' +
                      (scope.row.id - 1) +
                      '.jpg')
                  "
                  alt=""
                />
                <!-- <a :href="'#/schoolBrief/' + scope.row.name" target="_blank" >{{scope.row.name}}</a> -->
                <router-link
                  :to="{
                    path: '/configuration/schoolInfo',
                    query: { schoolName: scope.row.schoolName },
                  }"
                  target="_blank"
                  >{{ scope.row.schoolName }}</router-link
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column label="院校级别" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.grade != null">{{ scope.row.grade }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="position"
            label="省市"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="schoolType"
            label="院校类型"
            align="center"
          ></el-table-column>
          <el-table-column label="总分" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.schoolScore != null">{{
                scope.row.schoolScore
              }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
        <!--分页组件-->
        <div class="pagination-container" align="right">
          <el-pagination
            class="pagiantion"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="footer">
      <p>* 数据来源于软科2021中国大学排名</p>
    </div>
  </div>
</template>
<script>
import school from "../../api/configuration";
import category from "../../api/configuration";
export default {
  name: "ranking",
  data() {
    return {
      dataList: [], //当前页要展示的列表数据
      // 分页设置
      pagination: {
        //分页相关模型数据
        currentPage: 1, //当前页码
        pageSize: 20, //每页显示的记录数
        total: 0, //总记录数
      },
      schoolName: "",
    };
  },
  methods: {
    getSchoolRank() {
      let params = {
        current: this.pagination.currentPage,
        size: this.pagination.pageSize,
        schoolName: this.schoolName,
      };
      school.getSchoolRank(params).then((res) => {
        this.dataList = res.list;
        this.pagination.total = res.total;
      });
    },
    //切换页码
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage;
      this.getSchoolRank();
    },
  },
  created() {
    this.getSchoolRank();
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-size: 16px;
}
.app-container {
  height: 100vh;
  overflow: auto;
}
.app {
  width: 80%;
  margin: 0 auto;
}
.title {
  font-size: 18px;
  width: 100%;
  height: 50px;
  line-height: 50px;
}
.title .left {
  float: left;
}
.title .left p {
  margin-left: 15px;
  color: #606266;
}
.title .left p span {
  margin-left: 15px;
  font-size: 14px;
  color: #ccc;
}
.title .right {
  position: relative;
  float: right;
}
.title .right input {
  width: 220px;
  height: 32px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-right: 10px;
  padding: 0 20px;
  color: #606266;
  font-size: 15px;
  outline: none;
}
.title .right input:focus {
  border: 1px solid orange;
}
.title .right i {
  position: absolute;
  right: 25px;
  top: 16px;
  font-size: 18px;
  color: #606266;
}
.pagination-container {
  margin-top: 5px;
}
.dalfbut {
  width: 200px;
  height: 40px;
  border-radius: 4px;
  background-color: #66b1ff;
  color: #fff;
  margin: 20px 0;
  margin-right: 20px;
  background-color: #fff;
  color: #000;
  border: 1px solid #1db278;
}
.dalfbut:hover {
  color: #fff;
  background-color: #1db278;
}

a {
  color: #606266;
}

a:hover {
  color: #1cb278;
  text-decoration: underline;
}

.proInfo ul {
  display: flex;
  list-style: none;
}
.proInfo ul li {
  float: left;
  flex: 1;
  text-align: center;
}
img {
  width: 60px;
  vertical-align: middle;
  margin-right: 10px;
}
.img {
  text-align: left;
  margin-left: 10px;
}
.pagination-container .pagiantion {
  font-size: 16px;
}
.box {
  width: 100%;
  height: 80px;
  background-image: url(../../assets/img/school-rank.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 0 -170px;
  text-align: center;
  line-height: 80px;
  font-size: 32px;
  color: #fff;
  letter-spacing: 20px;
  opacity: 0.8;
}

.footer {
  margin: 20px 0 70px -43px;
}

.footer p{
  margin-left: 200px;
  color: #bbb;
}
</style>